import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./PayPalConfirmPayment.css"
const API_URL = process.env.REACT_APP_API_URL;

function ThanksDeposit() {
    const [orderId, setOrderId] = useState(null);
    const [responseMsg, setResponseMsg] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [total, setTotalAmount] = useState(null);
    const token = Cookies.get("Token");
    const navigate = useNavigate();
    // useEffect(() => {
    //     const queryParams = new URLSearchParams(window.location.search);

    //     const orderID = queryParams.get('orderID');
    //     const responseCode = queryParams.get('neo_ResponseCode');

    //     const newUrl = `${window.location.origin}/thanks?orderID=${orderID}&status=${responseCode === '0' ? 'success' : 'failed'}`;
    //     window.history.replaceState({}, '', newUrl);
    // }, []);
    useEffect(() => {
        const fetchUrlParams = () => {
            const urlParams = new URLSearchParams(window.location.search);
            setResponseMsg(urlParams.get("neo_ResponseMsg"));
            setOrderId(urlParams.get("neo_OrderID"));
            setPaymentMethod(urlParams.get("neo_PaymentMethod"));
            setTotalAmount(urlParams.get("neo_Amount"))

        };

        fetchUrlParams();
    }, []);


    useEffect(() => {
        const timer = setTimeout(() => {
            if (responseMsg === "Success") {
                navigate("/cshp/create");
            } else if (responseMsg !== "Success") {
                navigate(`/recharge`);
            }
        }, 510000);

        return () => clearTimeout(timer);
    }, [responseMsg, navigate, orderId]);



    return (
        <div className="container">
            <div className="">
                <div className="payment-container">
                    <div className="payment-card">
                        {responseMsg === "Success" ? (
                            <>
                                <p className="payment-status success">Trạng thái thanh toán: Thành công</p>
                                {paymentMethod != "" ?
                                    <p className="payment-thankyou">
                                        Cảm ơn quý khách đã nạp tiền thành công. Số dư của bạn đã được cập nhật. Xin vui lòng kiểm tra email để biết thêm chi tiết.
                                    </p>
                                    :
                                    <p className="payment-thankyou">
                                        Cảm ơn quý khách đã nạp tiền thành công. Xin quý khách vui lòng đợi trong ít phút, hệ thống sẽ tự động cộng tiền vào tài khoản.
                                    </p>
                                }




                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate("/cshp/create")}
                                >
                                    Trở về trang Khởi Tạo Máy Chủ CSHP
                                </button>
                            </>
                        ) : (
                            <>
                                <p className="payment-status pending">
                                    Vui lòng hoàn tất dịch vụ nạp tiền của quý khách.
                                </p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate(`/recharge`)}
                                >
                                    Trở về trang nạp tiền
                                </button>
                            </>
                        )}
                    </div>
                </div>

            </div>
        </div>

    );
}

export default ThanksDeposit; 